<template lang="html">
  <div class="e2e-home page-submenu">
      <div class="e2e-container" style="display: flex;justify-content:space-between;">
          <div class="page-submenu_left">
            <div class="e2e-content-box">
                <left-bar tab='user-authorizelm'></left-bar>
            </div>
          </div>
          <div class="page-submenu_right">
            <div class="e2e-content-box">
                <div class='user-container'>
                    <div class="user-basic-container" style="width: 400px">
                        <div class="e2e-form">
                            <el-form ref="ruleForm" :rules="rules" :model="form" label-position="top">
                                <el-form-item v-if="isAdmin" label="授权人AD" prop="licensorAd">
                                    <el-select placeholder="请选择（可搜索）" v-model="form.licensorAd" filterable remote :remote-method="remoteMethodLAD" style="width: 100%;">
                                    <el-option v-for="item in licensorList" :key="item.id" :value="item.adAccount" :label="item.workerNameLocal+' '+item.adAccount">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                                <div class="form-item">
                                    <el-radio v-model="radio" label="1">授权天数</el-radio>
                                    <el-radio v-model="radio" label="2">授权日期</el-radio>
                                    <span class="radio-after-text">（最长授权时间180天）</span>
                                </div>
                                <el-form-item label="授权天数" v-if="radio === '1'" prop="days">
                                    <el-select placeholder="请选择" v-model="form.days" style="width: 100%;">
                                    <el-option v-for="item in daysList" :key="item.id" :value="item.id" :label="item.label">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                                <el-form-item label="授权日期" v-if="radio === '2'" prop="date">
                                    <el-date-picker
                                    v-model="form.date"
                                    type="date"
                                    placeholder="选择日期"
                                    :picker-options="pickerOptions"
                                    style="width: 100%;"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="被授权人AD" prop="authorizedPersonAd">
                                    <el-select placeholder="请选择（可搜索）" v-model="form.authorizedPersonAd" filterable remote :remote-method="remoteMethodAPAD" style="width: 100%;" @change="changeAuthorizedPersonAd">
                                    <el-option v-for="item in authorizedPersonList" :key="item.id" :value="item.adAccount" :label="item.workerNameLocal+' '+item.adAccount">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                                <el-form-item style="margin-top: 20px;">
                                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                                    <el-button @click="$router.go(-1)">取消</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>                    
                </div>
                <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                width="500px"
                :show-close="true"
                        :center="true"
                >
                <span>{{dialogText1}}<br><br>{{dialogText2}}<br>{{dialogText3}}</span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="handlerOK()">确 定</el-button>
                </span>
                </el-dialog>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import api from "@/api/user/authorize";
import LeftBar from "../../LeftBar";
import { mapGetters } from "vuex";

export default {
  components: {
    LeftBar,
  },
  data() {
    return {
      authorizedPersonName:'',
      form: {
        authorizationType: "1",
      },
      isAdmin: false,
      licensorList: [],
      authorizedPersonList: [],
      daysList: [
        { id: 30, label: "30天" },
        { id: 60, label: "60天" },
        { id: 90, label: "90天" },
        { id: 180, label: "180天" },
      ],
      radio: "1",
      dialogVisible: false,
      dialogText1: "",
      dialogText2: "",
      dialogText3: "",
      rules: {
        licensorAd: [
          { required: true, message: "请选择授权人AD", trigger: "change" },
        ],
        days: [
          { required: true, message: "请选择授权天数", trigger: "change" },
        ],
        date: [
          {
            type: "date",
            required: true,
            message: "请选择授权日期",
            trigger: "change",
          },
        ],
        authorizedPersonAd: [
          { required: true, message: "请选择被授权人AD", trigger: "change" },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          time = new Date(moment(time).format("YYYY-MM-DD"));
          const diyDate = new Date();
          const startDate = new Date(diyDate.setDate(diyDate.getDate() - 1));
          const endDate = new Date(diyDate.setDate(diyDate.getDate() + 180));
          if (time.getTime() < startDate.getTime()) {
            return true;
          }
          if (time.getTime() > endDate.getTime()) {
            return true;
          }
          return false;
        },
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    changeAuthorizedPersonAd(val) {
      console.log(val)
      const authorizedPersonSelected = this.authorizedPersonList.filter(item => {
        return item.adAccount === val
      })
      this.authorizedPersonName = authorizedPersonSelected[0].workerNameLocal

    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.radio === "1") {
            this.form.authorizationDeadline = undefined;
            this.form.authorizationDays = this.form.days;
          } else {
            this.form.authorizationDays = undefined;
            this.form.authorizationDeadline = moment(this.form.date).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          }
          api.check(this.form).then((res) => {
            if (res.isSameFranchise) {
              this.dialogText1 = `即将把【直线经理】审批权限赋予给${this.authorizedPersonName}。`;
              this.dialogText2 = "•点击确认按钮后赋权生效，本账户将失去【直线经理】审批权限。";
              this.dialogText3 = "•可以在授权页面查看和维护授权功能。";
              this.dialogVisible = true;
            } else {
              this.dialogText1 = `即将把【直线经理】审批权限赋予给${this.authorizedPersonName}，${this.authorizedPersonName}不属于${res.authorizationTeam}团队，请确认授权对象。`;
              this.dialogText2 = "•点击确认按钮后赋权生效，本账户将失去【直线经理】审批权限。";
              this.dialogText3 = "•可以在授权页面查看和维护授权功能。";
              this.dialogVisible = true;
            }
          });
        } else {
          return false;
        }
      });
    },
    remoteMethodLAD(query) {
      if (query !== "") {
        api
          .approveUser({
            authorizationType: this.form.authorizationType,
            licensorAd: query,
          })
          .then((res) => {
            this.licensorList = res;
          });
      } else {
        this.licensorList = [];
      }
    },
    remoteMethodAPAD(query) {
      if (query !== "") {
        api.selectUser({ authorizedPersonAd: query }).then((res) => {
          this.authorizedPersonList = res;
        });
      } else {
        this.authorizedPersonList = [];
      }
    },
    handlerOK() {
      api.save(this.form).then((res) => {
        if (res) {
          this.$router.go(-1);
        }
        this.dialogVisible = false;
      });
    },
  },
  mounted() {
    for (let index = 0; index < this.userInfo.roleCodes.length; index++) {
      const element = this.userInfo.roleCodes[index];
      if (element == 140) {
        this.isAdmin = true;
        break;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.el-form {
  /deep/ .el-form-item__content {
    margin-bottom: 20px;
  }
}
.user-container {
  padding: 48px 80px 56px;
  display: flex;
  .form-item {
    padding: 10px 0 4px 0;
    .radio-after-text {
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?8278738a